import { render, staticRenderFns } from "./ValueExpiring.vue?vue&type=template&id=13a5b567&scoped=true&"
import script from "./ValueExpiring.vue?vue&type=script&lang=js&"
export * from "./ValueExpiring.vue?vue&type=script&lang=js&"
import style0 from "./ValueExpiring.vue?vue&type=style&index=0&id=13a5b567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5b567",
  null
  
)

export default component.exports